import { render, staticRenderFns } from "./appealDetails.vue?vue&type=template&id=3c192362&scoped=true"
import script from "./appealDetails.vue?vue&type=script&lang=js"
export * from "./appealDetails.vue?vue&type=script&lang=js"
import style0 from "./appealDetails.vue?vue&type=style&index=0&id=3c192362&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c192362",
  null
  
)

export default component.exports